var scrollLinks = [].slice.call(document.querySelectorAll('.scroll-link'));

scrollLinks.forEach(function(scrollLink) {
	scrollLink.addEventListener('click', function(e) {
		if(this.tagName == 'A')
			e.preventDefault();

		scrollToElement(document.querySelector(this.getAttribute('href')));
	});
});

var sectionId = window.location.hash,
	section = sectionId ? document.querySelector(sectionId) : false;

if(section) {
	setTimeout(function() {
		scrollToElement(section);
	}, 300);

	if(section.parentNode.classList.contains('accordion')) {
		setTimeout(function() {
			Velocity(section.querySelector('.answer'), 'slideDown', {duration: 250});

			var button = section.querySelector('button');

			button.classList.add('open');

			button.setAttribute('aria-expanded', 'true');
		}, 1200);
	}
}